import { managedFetch } from 'query/fetch';
import { useEffect, useState } from 'react';

export default function useCheckVersion() {
    const [version, setVersion] = useState<string | null>(null);

    useEffect(() => {
        const checkVersion = async () => {
            try {
                const data = await managedFetch('/meta.json?_t=' + Date.now(), {
                    cache: 'no-store',
                }, async response => {
                    if (!response.ok) throw new Error(`Version check failed: ${response.status}`);
                    return response.json();
                });
                const currentVersion = sessionStorage.getItem('app_version');

                if (currentVersion && currentVersion !== data.version) {
                    sessionStorage.setItem('app_version', data.version);
                    window.location.reload();
                } else if (!currentVersion) {
                    sessionStorage.setItem('app_version', data.version);
                }

                setVersion(data.version);
            } catch (err) {
                console.error('Version check failed:', err);
            }
        };

        checkVersion();
        const interval = setInterval(checkVersion, 10000);
        return () => clearInterval(interval);
    }, []);

    return version;
}